import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=004146a5"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"
import style0 from "./icon.vue?vue&type=style&index=0&id=004146a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports